import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ServiceCardSkeleton = () => {
  return (
    <div className="row">
      {Array(8) // Assuming 6 skeletons, you can adjust the number
        .fill(null)
        .map((_, index) => (
          <div
            className="col-lg-3 col-md-4 col-sm-6 col-xs-12 my-4 min-h-100"
            key={index}
          >
            <div className="d-flex flex-column h-100">
              {/* Image Skeleton */}
              <div>
                <Skeleton
                  height={205}
                  width="100%"
                  style={{ objectFit: 'fill' }}
                />
              </div>

              <div
                className="flex-grow-1"
                style={{
                  overflow: 'hidden',
                  paddingBottom: '10px',
                }}
              >
                {/* Title Skeleton */}
                <Skeleton width="80%" height={20} />

                {/* Description Skeleton */}
                <Skeleton count={3} width="100%" height={15} />
              </div>

              {/* Button Skeletons */}
              <div className="mt-auto">
                <Skeleton width={120} height={40} />
                <div className="d-flex mt-2">
                  <Skeleton width={90} height={40} />
                  <Skeleton width={90} height={40} className="ms-2" />
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ServiceCardSkeleton;
